import { formatDate } from '@angular/common';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConSultaModel, ResponseConSultasModel } from 'src/app/model/Consulta.model';
import { ContactoModel, ContactoTutorModel } from 'src/app/model/Contacto.model';
import { DatosActa, Participantes } from 'src/app/model/DatosActa.model';
import { JardinModel, ResponseJardinModel } from 'src/app/model/Jardin.model';
import { JardinTutorModel, ResponseJardinTutorModel } from 'src/app/model/JardinTutorDetail.model';
import { JardinTutoria } from 'src/app/model/JardinTutoria.model';
import { ResponseTutor, Tutor } from 'src/app/model/Tutor.model';
import { ResponseTutorDisponibilidad } from 'src/app/model/TutorDisponibilidad';
import { apiService } from 'src/app/service/api.service';
import { StorageService } from 'src/app/service/storage.service';
import { TutorService } from 'src/app/service/tutor.service';
import { TutoriaService } from 'src/app/service/tutoria.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inicio-tutor',
  templateUrl: './inicio-tutor.component.html',
  styleUrls: ['./inicio-tutor.component.css']
})
export class InicioTutorComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  cargando = true;
  tutor : Tutor;
  @ViewChild('modalCrearActa') modalCrearActa: TemplateRef<any>;
  @ViewChild('modalHistorial') modalHistorial: TemplateRef<any>;
  formContacto = new ContactoTutorModel();
  consulta : string;
  misJardines =[];
  responseConSultasModel=[];
  public rows : DetailColapse[] = [];
  public jardines : DetailColapseJardin[] = [];
  erores : string;
  showSimulacion : boolean;
  jardinSeleccionado: JardinModel;

  modalData: {
    jardinTutoria: JardinTutoria,
    jardinTutorModel:JardinTutorModel,
    modelDate: NgbDateStruct,
    timeInit : {},
    timeEnd : {},
    datosActa : DatosActa;
  };
  
  modelDate : NgbDateStruct;
  

  constructor(
    private modal: NgbModal,
    private storageService: StorageService,
    private api: apiService,
    private tutorService: TutorService,
    private tutoriaService: TutoriaService) { }

  ngOnInit(): void {
    this.jardinSeleccionado = null;
    this.misJardines = new Array<JardinTutorModel>();
    this.jardines = new Array<DetailColapseJardin>(); 
    this.cargando = true;
    this.showSimulacion = false;
    this.erores = "";
    this.consulta = "";
    this.buscaTutor();
  }


  buscaTutor(){
    this.tutorService.API_POST_getTutorObjectByIdUsuario(this.storageService.getCurrentUser().idUsuario).subscribe((response: ResponseTutor) => {
      this.tutor = response.payload; 
      this.buscarMisUnidadesEducativas();
    },
    (err) => {
      console.log("error"+err)
      this.cargando = false;
    });
  }

  buscarMisUnidadesEducativas(){
    this.tutorService.API_POST_getMisUnidadesEducativas(this.tutor.idPersonaPeriodo).subscribe((response: ResponseJardinTutorModel) => {
      this.misJardines = response.payload;  
      this.misJardines.forEach(key => {
        var detailColapseJardin = new DetailColapseJardin();
        detailColapseJardin.detail = key;
        this.jardines.push(detailColapseJardin);
      });
      this.getMisConsultas();
      this.cargando = false;
    },
    (err) => {
      console.log("error"+err)
    });
  }


  abrirModalHistorial(){
    this.modal.open(this.modalHistorial, { size: 'lg' });
  }


  enviarMensaje(){
    this.formContacto.idPersonaPeriodo = this.tutor.idPersonaPeriodo;
    this.formContacto.asunto = "duda o consulta"
    this.formContacto.consulta = this.consulta;
    this.divSpinner.nativeElement.style.display='';
    if(this.consulta != ""){
      this.tutorService.API_POST_crearConsultaTutor(this.formContacto).subscribe((response) => {
        this.formContacto = new ContactoTutorModel();
        this.consulta = "";
        this.getMisConsultas();
        this.divSpinner.nativeElement.style.display='none';
        Swal.fire({
          icon: 'success',
          title: 'Su Consulta se ha Enviado',
          confirmButtonText: 'OK'
        })
      },
      (err) => {
        console.log(err)
      })
    }else{
      this.divSpinner.nativeElement.style.display='none';
      Swal.fire({
        title: 'Error!',
        text: 'El Mensaje es Obligatorio',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    }
    
  
}


getMisConsultas(){
  this.tutorService.API_POST_obtenerMisConsultasTutor(this.tutor.idPersonaPeriodo).subscribe((response: ResponseConSultasModel) => {
    this.responseConSultasModel = response.payload;
    this.responseConSultasModel.forEach(key => {
      var detailColapse = new DetailColapse();
      detailColapse.detail = key;
      this.rows.push(detailColapse);
    });
    this.divSpinner.nativeElement.style.display='none';
  },
  (err) => {
    console.log(err)
  })
}

hacerActa(jardinTutoria : JardinTutoria,jardinTutorModel:JardinTutorModel){
  
  let fechaInicio = new Date(jardinTutoria.fechaInicioTutoria);
  let fechaFin = new Date(jardinTutoria.fechaFinTutoria);

  fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
  fechaFin.setTime( fechaFin.getTime() + fechaFin.getTimezoneOffset()*60*1000 );

  var modelDate = this.modelDate;
  modelDate = {"year": fechaInicio.getFullYear(),"month": fechaInicio.getMonth() + 1, "day": fechaInicio.getDate()};
  var timeInit = {hour:  fechaInicio.getHours(), minute: fechaInicio.getMinutes()};
  var timeEnd = {hour:  fechaFin.getHours(), minute: fechaFin.getMinutes()};
  var datosActa = new DatosActa();
  this.modalData = { jardinTutoria,jardinTutorModel,modelDate, timeInit,timeEnd,datosActa};
  this.modal.open(this.modalCrearActa, { size: 'lg' });
}

close(){
  this.erores = "";
  this.modal.dismissAll();
}

enviar(modalData){
  let numeroParticipantesValido = modalData.datosActa.numeroParticipantes > 0;
  let fechaValida = modalData.modelDate != null;
  let fechaFinValida = modalData.timeEnd != null;
  let fechaInicioValida =  modalData.timeInit != null ;
  let comentarioValido = modalData.datosActa.comentario != "";
  if(numeroParticipantesValido && fechaValida && fechaFinValida && fechaInicioValida && comentarioValido){
    var datosActa = new DatosActa();
    datosActa.comentarioTutor = modalData.datosActa.comentarioTutor;
    datosActa.idJardinPeriodoTutoria = modalData.jardinTutoria.idJardinPeriodoTutoria;
    var start = new Date(modalData.modelDate.year, modalData.modelDate.month , modalData.modelDate.day, modalData.timeInit.hour, modalData.timeInit.minute, 0, 0);
    var end = new Date(modalData.modelDate.year, modalData.modelDate.month , modalData.modelDate.day, modalData.timeEnd.hour, modalData.timeEnd.minute, 0, 0);
   
    start.setHours( start.getHours() - 3 );
    end.setHours( end.getHours() - 3 );

    start.setMonth( start.getMonth() - 1 );
    end.setMonth( end.getMonth() - 1 );

   
    datosActa.fechaInicio = start;
    datosActa.fechaFin = end;
    datosActa.numeroParticipantes = modalData.datosActa.numeroParticipantes;
    datosActa.participantes = modalData.datosActa.participantes;


    this.divSpinner.nativeElement.style.display='';

      this.tutoriaService.API_POST_crearActaTutor(datosActa).subscribe((response) => {
        this.close();
        this.divSpinner.nativeElement.style.display='none';
        this.ngOnInit();
      },
      (err) => {
        console.log(err)
      })
    

    this.erores = "";
  }else{
    this.erores = "debe completar todos los campos" 
  }

  
}


simular(jardinTutorModel : JardinTutorModel){
  this.divSpinner.nativeElement.style.display='';
  this.api.API_POST_obtenerJardinPorRBD(parseInt(jardinTutorModel.rbd)).subscribe((response:ResponseJardinModel) => {
    this.api.dataJardin = response.payload;
    this.jardinSeleccionado = response.payload;
    this.tutorService.tutor = this.tutor;
    this.showSimulacion = true;
    this.divSpinner.nativeElement.style.display='none';
  },
  (err) => { 
    console.log(err)
    this.divSpinner.nativeElement.style.display='none';
    Swal.fire({
      title: 'Error!',
      text: 'Error al Cargar Jardín',
      icon: 'error',
      confirmButtonText: 'OK'
    })
  })
  
}


agregarParticipante(participante,rol,participantes:Participantes[],numeroParticipantes,datosActa){
  let participanteAdd = new Participantes();
  participanteAdd.participante = participante.value;
  participanteAdd.rol = rol.value;
  participante.value = "";
  rol.value = "";
  let numeroParticipante = parseInt(numeroParticipantes.value) + 1;
  participanteAdd.id = numeroParticipante;
  participantes.push(participanteAdd);
  numeroParticipantes.value = numeroParticipante;
  datosActa.numeroParticipantes = numeroParticipante;
}

eliminarParticipante(participante:Participantes,participantes:Participantes[],numeroParticipantes,datosActa){
  
  participantes.forEach((par, index)=>{
    if(par.id === participante.id) {
      participantes.splice(index,1);
      return;
    }
  });
  let numeroParticipante = parseInt(numeroParticipantes.value) - 1;
  numeroParticipantes.value = numeroParticipante;
  datosActa.numeroParticipantes = numeroParticipante;
}

}



export class DetailColapseJardin{
  detail:JardinTutorModel;
  isCollapsed:boolean;

  constructor(){
    this.detail = null;
    this.isCollapsed = true;
  }

}

export class DetailColapse{
  detail:ConSultaModel;
  isCollapsed:boolean;

  constructor(){
    this.detail = null;
    this.isCollapsed = true;
  }

}